var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGdprFeature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 64,
    height: 64,
    rx: 19.5,
    stroke: "#19C48F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_54_1323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.37 35.4788L44.8275 39.7363C44.9286 39.9116 44.9857 40.1088 44.9939 40.311C45.0021 40.5132 44.9611 40.7144 44.8744 40.8973C44.7878 41.0801 44.6581 41.2393 44.4964 41.361C44.3348 41.4828 44.146 41.5635 43.9463 41.5963L43.805 41.61L43.665 41.6088L39.9988 41.3713L38.37 44.6663C38.2816 44.8447 38.1519 44.9994 37.9916 45.1176C37.8314 45.2358 37.6452 45.3141 37.4486 45.3458C37.2521 45.3776 37.0507 45.362 36.8614 45.3004C36.6721 45.2387 36.5002 45.1327 36.36 44.9913L36.2575 44.8738L36.1675 44.7363L33.7075 40.4775C35.4392 40.3693 37.1224 39.8617 38.6252 38.9944C40.1281 38.1272 41.4098 36.9239 42.37 35.4788Z",
    fill: "#19C48F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2875 40.4775L29.83 44.7375C29.7304 44.9101 29.5911 45.0564 29.4235 45.1643C29.256 45.2721 29.0651 45.3384 28.8668 45.3576C28.6685 45.3768 28.4684 45.3484 28.2833 45.2747C28.0982 45.2009 27.9333 45.0841 27.8025 44.9338L27.7075 44.8088L27.6275 44.6663L25.9975 41.3725L22.3338 41.61C22.1319 41.623 21.93 41.5869 21.7452 41.5047C21.5604 41.4226 21.3983 41.2969 21.2727 41.1384C21.1471 40.9799 21.0618 40.7933 21.0241 40.5946C20.9864 40.3959 20.9975 40.191 21.0563 39.9975L21.1063 39.8638L21.1688 39.7388L23.6288 35.4775C24.5884 36.9227 25.8694 38.1262 27.3715 38.9938C28.8737 39.8614 30.5562 40.3684 32.2875 40.4775Z",
    fill: "#19C48F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 20.5L33.3 20.505C35.5674 20.5828 37.7159 21.5382 39.2924 23.1697C40.8689 24.8012 41.75 26.9813 41.75 29.25L41.7463 29.4913L41.7375 29.7313L41.715 30.0375L41.6825 30.34L41.6525 30.5625C41.5702 31.1021 41.4376 31.6327 41.2562 32.1475L41.1112 32.5325L40.92 32.9675C40.2123 34.475 39.0893 35.7493 37.6826 36.6407C36.276 37.5321 34.6442 38.0037 32.9789 38C31.3135 37.9963 29.6838 37.5176 28.2812 36.6199C26.8785 35.7223 25.761 34.4431 25.06 32.9325L24.8975 32.5613L24.8325 32.395L24.7325 32.1237L24.6137 31.7563C24.5713 31.6139 24.5326 31.4706 24.4975 31.3263L24.4225 30.9875L24.3613 30.6488L24.3362 30.475L24.2875 30.0712L24.2575 29.615L24.25 29.25C24.25 26.9813 25.1311 24.8012 26.7076 23.1697C28.2841 21.5382 30.4326 20.5828 32.7 20.505L33 20.5Z",
    fill: "#19C48F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_54_1323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(18 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGdprFeature);
export default __webpack_public_path__ + "static/media/gdpr_feature.71d57932deb44e730b95209868e33125.svg";
export { ForwardRef as ReactComponent };